import AdvancedController from "../advanced-controller";
import lottie from "lottie-web";
import Hunt from "huntjs";
import { breakpointDown } from "../utils";

export class OffsetTeaserController extends AdvancedController {
  lottiePlayer = null;

  static targets = ["animation"];
  static values = {
    animation: { type: String, default: "" },
  };
  connect() {
    super.connect(...arguments);

    let offset = (-1 * window.innerHeight) / 100;
    offset *= breakpointDown("md") ? 60 : 50;
    new Hunt(this.element, {
      offset: offset,
      enter: (el) => {
        if (this.lottiePlayer) {
          this.lottiePlayer.play();
        }
      },
    });
  }
  disconnect() {
    super.disconnect(...arguments);
  }

  animationValueChanged(newValue) {
    if (newValue) {
      this._loadAnimation();
    }
  }
  _loadAnimation() {
    this.lottiePlayer = lottie.loadAnimation({
      container: this.animationTarget,
      renderer: "svg",
      loop: false,
      autoplay: false,
      path: this.animationValue,
    });
  }
}
